import { Alert } from '@/components/shared/alert';
import { Modal } from '@/components/shared/modal';
import { ModalFormSkeleton } from '@/components/shared/modal-form-skeleton';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
  useGetAllRestaurantCompaniesQuery,
  useGetSingleCompanyLocationGroupQuery,
} from '@durma-soft/gros-sdk';
import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate, useParams } from 'react-router-dom';
import { EditRestaurantCompanyGroupsForm } from './edit-restaurant-company-group-form';

export const EditRestaurantCompanyGroupsModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { groupId } = useParams();

  if (!groupId) {
    throw new Error('Group ID are required for editing group');
  }

  const restaurant = useAuthUserRestaurant();
  const hasEditPermission = restaurant.role !== RESTAURANT_USER_ROLE.EMPLOYEE;

  const {
    data: group,
    isSuccess,
    isError,
    isLoading,
  } = useGetSingleCompanyLocationGroupQuery({
    restaurant_id: restaurant.id,
    location_group_id: +groupId,
  });

  const { data: companiesAndGroups, isLoading: isLoadingCompanies } =
    useGetAllRestaurantCompaniesQuery(restaurant.id);

  const closeModal = () =>
    navigate('/restaurant/companies/groups', { replace: true });

  const isModalOpen = Boolean(
    useMatch({ path: '/restaurant/companies/groups/edit/:groupId' }),
  );

  return (
    <Modal
      key={groupId}
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('company.groups.edit')}
      description={t('company.groups.edit-details')}
    >
      {isLoading && <ModalFormSkeleton />}
      {!hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.edit-not-allowed')}
          description={t('common.edit-not-allowed-description')}
        />
      )}
      {isError && hasEditPermission && (
        <Alert
          variant="destructive"
          title={t('common.error')}
          description={t('common.try-later')}
        />
      )}
      {isSuccess && hasEditPermission && (
        <EditRestaurantCompanyGroupsForm
          group={group}
          companies={companiesAndGroups?.companies || []}
          isLoadingCompanies={isLoadingCompanies}
          onClose={closeModal}
        />
      )}
    </Modal>
  );
};
